// <button data-dialog-open="id"> opens the <dialog id="id"> as a modal, [data-dialog-close] and a
// click on the backdrop close it. Delegated on document, so it also works inside lazy frames.
document.addEventListener("click", (event) => {
  const opener = event.target.closest("[data-dialog-open]")
  if (opener) {
    document.getElementById(opener.dataset.dialogOpen)?.showModal()
    return
  }

  if (event.target.closest("[data-dialog-close]")) {
    event.target.closest("dialog")?.close()
    return
  }

  if (event.target instanceof HTMLDialogElement) event.target.close()
})
